import * as Yup from 'yup';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export default {
  login: Yup.object().shape({
    email: Yup.string()
      .email('Must be a valid email')
      .max(255)
      .required('Email is required'),
    password: Yup.string().max(255).required('Password is required')
  }),
  lead: Yup.object().shape({
    email: Yup.string()
      .email('Must be a valid email')
      .max(255)
      .required('Email is required'),
    title: Yup.string()
      .required('Title is required'),
    firstName: Yup.string()
      .required('First name is required'),
    lastName: Yup.string()
      .required('Last name is required'),
    middleName: Yup.string()
      .required('Middle name is required'),
    address1: Yup.string()
      .required('Address 1 is required'),
    address2: Yup.string()
      .required('Address 2 is required'),
    city: Yup.string()
      .required('City is required'),
    state: Yup.string()
      .required('State is required'),
    zip: Yup.string()
      .required('Zip is required'),
    phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Phone number is required'),
    cellPhone: Yup.string().matches(phoneRegExp, 'Cell phone is not valid').required('Cell phone is required'),
    notes: Yup.string()
      .required('Notes is required'),
  }),

};
